import { CommonModule } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';

import type { StoryblokRichTextDoc } from '@storyblok/richtext';
import { DynamicModule } from 'ng-dynamic-component';

import { SheetModule } from '@valk-nx/components/ui-sheet/src/lib/sheet.module';
import type { TileAlignment } from '@valk-nx/components/ui-tile/src/lib/tile';
import { TileComponent } from '@valk-nx/components/ui-tile/src/lib/tile';
import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import type { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';
import { createInternalLinkRenderer } from '@valk-nx/storyblok/components/richtext/src/lib/custom-resolvers';
import { RichTextComponent } from '@valk-nx/storyblok/components/richtext/src/lib/rich-text';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import type { Link } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

export interface Tile {
	title: string;
	icon: string;
	description: string | StoryblokRichTextDoc;
}
@Component({
	selector: 'sb-tile-group-section',
	templateUrl: './tile-group-section.html',
	imports: [
		CommonModule,
		DynamicModule,
		HeadingDirective,
		RichTextComponent,
		SheetModule,
		StoryblokDirective,
		TileComponent,
	],
})
export class TileGroupSectionComponent extends StoryblokRootDirective {
	tiles = input.required<Tile[]>();
	title = input.required<string>();

	headingType = input<HeadingType>('h2');

	prependInternalLinksWith = input<string>('');
	headerLink = input<Link>();
	headerLinkText = input<string>();
	tileAlignment = input<TileAlignment>('vertical');

	selectedTile = signal<Tile | undefined>(undefined);

	showHeaderLink = computed(() => {
		return this.headerLink() && this.headerLinkText();
	});

	richTextResolvers = computed(() => {
		if (this.prependInternalLinksWith() != '') {
			return {
				link: createInternalLinkRenderer(
					this.prependInternalLinksWith(),
				),
			};
		}
		return {};
	});

	constructor() {
		super();
	}

	onTileClick(tile: Tile) {
		this.selectedTile.set(tile);
	}

	onSheetClose() {
		this.selectedTile.set(undefined);
	}
}
